import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

const canonicalHosts: Record<string, string> = {
  'admin.babcockguesthouse.com': 'www.admin.babcockguesthouse.com',
  'staging-admin.babcockguesthouse.com': 'www.staging-admin.babcockguesthouse.com',
}

const canonicalHost = canonicalHosts[window.location.hostname]
if (canonicalHost) {
  window.location.replace(
    `${window.location.protocol}//${canonicalHost}${window.location.port ? `:${window.location.port}` : ''}${window.location.pathname}${window.location.search}${window.location.hash}`,
  )
}

// A deploy renames every hashed chunk; a browser mid-session may request a
// modulepreload chunk that no longer exists and gets index.html back. Reload
// once to pull the fresh build. Guarded so a genuine failure cannot loop.
window.addEventListener('vite:preloadError', () => {
  const key = 'chunk-reload-at'
  const last = Number(sessionStorage.getItem(key) || 0)
  if (Date.now() - last > 10_000) {
    sessionStorage.setItem(key, String(Date.now()))
    window.location.reload()
  }
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
